import PropTypes from 'prop-types';
import { Text, View } from '@react-pdf/renderer';

import { CATEGORY_COLORS, COLORS, styles } from './styles';

const PdfFindingCard = ({ finding }) => {
  const {
    number,
    label,
    category,
    detailedFeedback,
    reason,
    psychologyPrinciple,
    psychologyInsight,
    isDeeperInsight,
    highImpactRecommendation,
    actionSteps,
  } = finding;

  const badgeColor = CATEGORY_COLORS[category] || COLORS.warning;

  // Render feedback text with highlight
  const renderFeedbackText = () => {
    const text = detailedFeedback?.[0] || '';

    return (
      <Text style={styles.findingBody}>
        {text}
      </Text>
    );
  };

  return (
    <View style={styles.findingCard} wrap={false}>
      {/* Header with severity badge */}
      <View style={styles.findingHeader}>
        <View style={[styles.severityBadge, { backgroundColor: badgeColor }]}>
          <Text style={styles.findingIndex}>
            {'# '}
            {number}
          </Text>
        </View>
        {label && (
          <Text style={styles.findingLabel}>
            {label}
          </Text>
        )}
      </View>

      {/* Main feedback text */}
      {renderFeedbackText()}

      {/* Additional feedback items for non-deeper-insight findings */}
      {!isDeeperInsight && detailedFeedback?.length > 1 && detailedFeedback.slice(1).map((item, idx) => (
        <View style={styles.bulletItem} key={idx}>
          <Text style={styles.bulletText}>
            {item}
          </Text>
        </View>
      ))}

      {/* Deeper insight details */}
      {isDeeperInsight && highImpactRecommendation && (
        <View style={{ marginTop: 4 }}>
          <Text style={styles.recommendationLabel}>
            High-impact recommendation
          </Text>
          <Text style={styles.recommendationText}>
            {highImpactRecommendation}
          </Text>
        </View>
      )}

      {isDeeperInsight && actionSteps?.length > 0 && (
        <View style={{ marginTop: 2 }}>
          {actionSteps.map((step, idx) => (
            <View style={styles.actionStep} key={idx}>
              <Text style={styles.actionStepNumber}>
                {idx + 1}
                .
              </Text>
              <Text style={styles.actionStepText}>
                {step}
              </Text>
            </View>
          ))}
        </View>
      )}

      {/* Psychology section */}
      {psychologyPrinciple && psychologyInsight && (
        <View style={styles.psychologySection}>
          <Text style={styles.psychologyPrinciple}>
            {psychologyPrinciple}
          </Text>
          <Text style={styles.psychologyInsight}>
            {psychologyInsight}
          </Text>
        </View>
      )}

      {/* Why section */}
      {reason && !isDeeperInsight && (
        <View style={styles.whySection}>
          <Text style={styles.whyLabel}>
            Why
          </Text>
          <Text style={styles.whyText}>
            {reason}
          </Text>
        </View>
      )}
    </View>
  );
};

PdfFindingCard.propTypes = {
  finding: PropTypes.shape({
    number: PropTypes.number,
    label: PropTypes.string,
    category: PropTypes.string,
    detailedFeedback: PropTypes.array,
    reason: PropTypes.string,
    psychologyPrinciple: PropTypes.string,
    psychologyInsight: PropTypes.string,
    isDeeperInsight: PropTypes.bool,
    highImpactRecommendation: PropTypes.string,
    actionSteps: PropTypes.array,
  }),
};

export default PdfFindingCard;
